import { styled } from '@mui/material';
import AccordionDemo from 'pages/ComponentDemo/Accordion';
import AccordionRubricDemo from 'pages/ComponentDemo/AccordionRubric';
import AutocompleteDemo from 'pages/ComponentDemo/Autocomplete';
import AvatarDemo from 'pages/ComponentDemo/Avatar';
import AvatarButtonDemo from 'pages/ComponentDemo/AvatarButton';
import BottomBarDemo from 'pages/ComponentDemo/BottomBar';
import ButtonDemo from 'pages/ComponentDemo/Button';
import ButtonGroupDemo from 'pages/ComponentDemo/ButtonGroup';
import CardDemo from 'pages/ComponentDemo/Card';
import CheckboxDemo from 'pages/ComponentDemo/Checkbox';
import CollaboratorInputDemo from 'pages/ComponentDemo/CollaboratorInput';
import CompletionButtonDemo from 'pages/ComponentDemo/CompletionButton';
import CopyrightDemo from 'pages/ComponentDemo/Copyright';
import CourseCardDemo from 'pages/ComponentDemo/CourseCard';
import DatePickerDemo from 'pages/ComponentDemo/DatePicker';
import DialogDemo from 'pages/ComponentDemo/Dialog';
import DividerDemo from 'pages/ComponentDemo/Divider';
import DotProgressionDemo from 'pages/ComponentDemo/DotProgression';
import DrawerDemo from 'pages/ComponentDemo/Drawer';
import DropdownDemo from 'pages/ComponentDemo/Dropdown';
import EmailMultiInputDemo from 'pages/ComponentDemo/EmailMultiInput';
import FileUploadDemo from 'pages/ComponentDemo/FileUpload';
import FormDemo from 'pages/ComponentDemo/Form';
import IconDemo from 'pages/ComponentDemo/Icon';
import IconButtonDemo from 'pages/ComponentDemo/IconButton';
import InstructorAssignmentCard from 'pages/ComponentDemo/InstructorAssignmentCard';
import LinkDemo from 'pages/ComponentDemo/Link';
import LogoDemo from 'pages/ComponentDemo/Logo';
import MultiInputDemo from 'pages/ComponentDemo/MultiInput';
import NavButtonDemo from 'pages/ComponentDemo/NavButton';
import PanelDemo from 'pages/ComponentDemo/Panel';
import PanelButtonDemo from 'pages/ComponentDemo/PanelButton';
import PasswordInputDemo from 'pages/ComponentDemo/PasswordInput';
import ProgressBarDemo from 'pages/ComponentDemo/ProgressBar';
import RadioDemo from 'pages/ComponentDemo/Radio';
import ResourceChipDemo from 'pages/ComponentDemo/ResourceChip';
import ResponsiveDialogDemo from 'pages/ComponentDemo/ResponsiveDialog';
import RichTextAreaDemo from 'pages/ComponentDemo/RichTextArea';
import RichTextInputDemo from 'pages/ComponentDemo/RichTextInput';
import RubricTableDemo from 'pages/ComponentDemo/RubricTable';
import ScrollableTableDemo from 'pages/ComponentDemo/ScrollableTable';
import SelectDemo from 'pages/ComponentDemo/Select';
import SnackbarDemo from 'pages/ComponentDemo/Snackbar';
import SplitButtonDemo from 'pages/ComponentDemo/SplitButton';
import StepsDemo from 'pages/ComponentDemo/Steps';
import StudentAssignmentCardDemo from 'pages/ComponentDemo/StudentAssignmentCard';
import SubmissionCardDemo from 'pages/ComponentDemo/SubmissionCard';
import SwitchDemo from 'pages/ComponentDemo/Switch';
import TableDemo from 'pages/ComponentDemo/Table';
import TabsDemo from 'pages/ComponentDemo/Tabs';
import TagDemo from 'pages/ComponentDemo/Tag';
import TextDemo from 'pages/ComponentDemo/Text';
import TextAreaDemo from 'pages/ComponentDemo/TextArea';
import TextInputDemo from 'pages/ComponentDemo/TextInput';
import ThirdPartyButtonDemo from 'pages/ComponentDemo/ThirdPartyButton';
import TooltipDemo from 'pages/ComponentDemo/Tooltip';
import UploadFileDialogDemo from 'pages/ComponentDemo/UploadFileDialog';
import VideoDialogDemo from 'pages/ComponentDemo/VideoDialog';
import ViewMoreDemo from 'pages/ComponentDemo/ViewMore';
import { Container, Stack, Text } from 'shell/components';

const ComponentDemo = () => {
    return (
        <Container sx={{ pb: 2 }}>
            <Text variant={'h1'}>Components</Text>
            <Stack sx={{ flexWrap: 'wrap' }} direction={'row'} spacing={2}>
                <CustomStack spacing={2}>
                    <AccordionDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <AccordionRubricDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <AutocompleteDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <AvatarDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <AvatarButtonDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <BottomBarDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <ButtonDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <ButtonGroupDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <CardDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <CheckboxDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <CollaboratorInputDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <CompletionButtonDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <CopyrightDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <CourseCardDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <DatePickerDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <DialogDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <DividerDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <DrawerDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <DropdownDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <EmailMultiInputDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <FileUploadDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <FormDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <IconDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <IconButtonDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <InstructorAssignmentCard />
                </CustomStack>
                <CustomStack spacing={2}>
                    <LinkDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <LogoDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <MultiInputDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <NavButtonDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <PanelDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <PanelButtonDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <PasswordInputDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <ProgressBarDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <RadioDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <ResourceChipDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <ResponsiveDialogDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <TextDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <RichTextAreaDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <RichTextInputDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <RubricTableDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <ScrollableTableDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <SelectDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <SnackbarDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <DotProgressionDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <SplitButtonDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <StepsDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <StudentAssignmentCardDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <SubmissionCardDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <SwitchDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <TableDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <TabsDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <TagDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <TextAreaDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <TextInputDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <ThirdPartyButtonDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <TooltipDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <UploadFileDialogDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <VideoDialogDemo />
                </CustomStack>
                <CustomStack spacing={2}>
                    <ViewMoreDemo />
                </CustomStack>
            </Stack>
        </Container>
    );
};

const CustomStack = styled(Stack)(({ theme }) => ({
    alignItems: 'flex-start',
    border: `1px dashed ${theme.palette.ensightful.neutral[500]}`,
    borderRadius: '6px',
    minWidth: '250px',
    padding: theme.spacing(2),
}));

export default ComponentDemo;
